import React from "react";
import "components/Project/ActiveProject/ProjectComplete/ProjectComplete.css";
import "components/General/Video/Video.css";
import { Player } from "video-react";
import AxiosConfig from "axiosConfig";
import Image from "react-bootstrap/Image";

/**
 * @description Creates a summary of the volunteer time served as part of the challenge
 * @class VolunteerTimeSummary
 * @implements none
 * @extends React.Component
 * @type {VolunteerTimeSummary}
 * @example <VolunteerTimeSummary />
 * pre-condition: all the imports
 * post-condition: returns a form with all the information about volunteer time served
 * @param name, address, city, state, website, hours, description, video
 * @returns {VolunteerTimeSummary}
 */

class VolunteerTimeSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.projectSlug,
      hours: "",
      description: "",
      video: "",
      name: "",
      address: "",
      city: "",
      stateName: "",
      website: "",
      challengeSlug: this.props.challengeSlug,
    };
  }

  componentDidMount() {
    AxiosConfig.get(
      `impactprojects/volunteer_time/?project=${this.state.projectSlug}&challenge=${this.state.challengeSlug}&projectUserId=${this.props.projectUserId}`
    )
      .then((res) => {
        this.setState({
          name: res.data.organisation_name,
          address: res.data.organisation_address,
          city: res.data.organisation_city,
          website: res.data.organisation_website,
          stateName: res.data.organisation_state,
          hours: res.data.volunteer_hours,
          description: res.data.volunteer_work_description,
          video: res.data.exp_video?res.data.exp_video:this.props.video,
        });
      })
      .catch();
  }

  render() {
    const url = this.state.video;
    return (
      <div className="challenge-form">
        <div className="challenge-form-inner">
          <label>
            I reached my project goal of {this.props.challengeName} that
            supports the mission of the project:
          </label>
          <div className="mt-15 mb-15 d-inline-block w-100 addr-details">
            <label className="statement">
              I volunteered for:
            </label>
            <label className="statement">{this.state.name}</label>
            <label className="statement">{this.state.address}</label>
            <label className="statement">
              {this.state.city}, {this.state.stateName}
            </label>
            {this.state.website ? <label>{this.state.website}</label> : null}
          </div>
          <label className="mt-10 statement">
            Volunteer: I volunteered a total of <b>{this.state.hours} hours</b> by doing
            the following:
          </label>
          <label>Description: {this.state.description}</label>
          <div
            className="project-video-preview"
            style={{ width: this.props.width }}
          >
            {url.match(/\.(jpeg|jpg|gif|png|JPG|JPEG|PNG)$/) != null ? (
              <Image src={url} className="w-100" />
            ) : (
              <Player
                className="video-upload-preview"
                fluid={false}
                playsInline
                src={url}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default VolunteerTimeSummary;
